import { Calendar } from "primereact/calendar";
import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import Utils from "../../utilities/Utils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { spacing } from '../../theme';

interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    isEng: boolean;
}

interface State {

}
export class DateComponent extends React.Component<Props, State> {


    constructor(props: Props) {
        super(props);

        let field = this.props.field;
        field.Touched=false;
        FormValidationUtils.runJavascript(field);
    }

    onDateChangeOnDialog = (e) => {
        let field = this.props.field;
        let val = e.target.value;
        field.Touched=true;
        field.Value = this.convertToDateString(val);
        FormValidationUtils.validateDate(field)
        FormValidationUtils.runJavascript(field);

        let subSection: FormSubSections = this.props.field.parent as FormSubSections;

        this.props.callbackElement(subSection.parent.parent);

        let listScriptTriggering = subSection.ListOfFormSectionElements.filter(ele => ele.ScriptTriggerField == this.props.field.LoadBindName);
        if (listScriptTriggering.length > 0) {
            listScriptTriggering.forEach(ele => {
                if (ele.Script) {
                    eval(ele.Script);
                    this.props.callbackElement(subSection.parent.parent);
                }
            })
        }
    }

    convertToDateString = (val) => {
        const date = new Date(val);

       // Extract the month, day, and year
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based, so add 1
        const day = date.getDate().toString().padStart(2, '0');
        const year = date.getFullYear();

        // Format the date as MM/DD/YYYY
        const formattedDateString = `${month}/${day}/${year}`;
        return formattedDateString
    }

    render() {
        let field = this.props.field;
        if (!field.Visible) return null;

        let validateCpmpareField;
        let dateValid: boolean = true;

        let displayfield: boolean = true;
        let editable = this.props.editable;
        let labelControlArray = this.props.labelControlArray;
        let requiredField = this.props.requiredField;
        let controlArray = [];
        let title = this.props.title;

        if (this.props.field.FilterField != null) {
            let filterValue;
            let baseName;
            let bindName;
            let parts = this.props.field.FilterField.split('.');
            if (parts.length == 3) {
                baseName = parts[0] + '.' + parts[1];
                bindName = parts[2];
            }
            if (parts.length == 2) {
                baseName = parts[0];
                bindName = parts[1];
            }
            if (parts.length == 1) {
                baseName = '';
                bindName = parts[0];
            }

            let foundFilterFields = XMLParser.extractFormSectionElement(baseName, bindName);

            let foundFilterField;

            if (foundFilterFields && foundFilterFields.length > 0) {
                foundFilterField = foundFilterFields[0];
            }

            if (foundFilterField != null) {
                filterValue = foundFilterField.Value;

                if (filterValue == null || filterValue != null && this.props.field.FilterValue.indexOf(filterValue) == -1 && filterValue.indexOf(this.props.field.FilterValue) == -1) {
                    displayfield = false;
                }
            }
        }


        if (field.ValidateCompareMethod != null) {
            let subSection = this.props.field.parent as FormSubSections;
            let foundValidateCpmpareFieldList = subSection.ListOfFormSectionElements.filter(p => p.LoadBindName == field.ValidateCompareField);
            if (foundValidateCpmpareFieldList.length > 0) {
                validateCpmpareField = foundValidateCpmpareFieldList[0];
                if (field.ValidateCompareMethod == "<")
                    dateValid = field.Value <= validateCpmpareField.Value;
                else if (field.ValidateCompareMethod == ">") {
                    dateValid = field.Value >= validateCpmpareField.Value;
                } else {
                    dateValid = field.Value == validateCpmpareField.Value;
                }
            }
        }

        if (displayfield) {
            if (editable) {

                controlArray.push(
                    <div key={'div_' + field.Datatype + '_' + field.Id} id={'div_' + field.Datatype + '_' + field.Id} className="ontario-date">
                        {labelControlArray}

                        <LiveValidationErrMsg
                            field={this.props.field}
                            isEng={this.props.isEng}
                            key={"LiveValidationErrMsg_" + field.LoadBindName} />
                        {/* @ts-ignore */}
                        <Calendar showIcon 
                            value={(this.props.field.Value == '' || this.props.field.Value == null ? null : new Date(this.props.field.Value))}
                            disabled={field.ReadOnly}
                            id={field.LoadBindName} 
                            key={'fdIpt_' + field.Id} monthNavigator={true} yearNavigator={true} yearRange="1900:2100" ariaLabelledBy={'fd_date_' + field.Id}
                            onChange={this.onDateChangeOnDialog} required={requiredField} />
                        <span style={{ display: dateValid ? 'none' : 'block', color: 'red' }}>{field.ENUTitle + " must be " + field.ValidateCompareMethod + " " + validateCpmpareField?.ENUTitle}</span>
                    </div>);
            } else {
                    controlArray.push(
                        <div className='pdf-two-column'>
                            <div>{title}</div>
                            <div className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >{field.Value ? (new Date(field.Value)).toLocaleDateString() : null}</div>
                        </div>
                    );
            }
        }

        return controlArray;

    }

}